// extracted by mini-css-extract-plugin
export default {"autoRepeatPurchase":"PurchaseTypeTags_autoRepeatPurchase__qUDsq","monthlySubscription":"PurchaseTypeTags_monthlySubscription__lXKjV","tagText":"PurchaseTypeTags_tagText__RhO32"};